import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";
import { HoverCardShadow, HoverCardBorderLink } from "../styled/BPSCards";
import { BPSArrowLink, Arrow } from "../styled/Buttons";

import LogoACT from '../../assets/images/Sponsor - ACT.png';
import LogoNBDA from '../../assets/images/Sponsor - NBDA.png';
import LogoFosterLove from '../../assets/images/Sponsor - Foster Love.svg';
import LogoPeopleForBikes from '../../assets/images/Sponsor - People for Bikes.png';
import LogoT2T from '../../assets/images/Sponsor - T2T.png';

import RebateIcon from '../../assets/icons/BPS Icon - Rebate.png';
import ChannelIcon from '../../assets/icons/BPS Icon - Channel Incentives.png';
import RideshareIcon from '../../assets/icons/BPS Icon - Ridesharing.png';
import SalesContestIcon from '../../assets/icons/BPS Icon - Sales Contest.png';
import MarketResearchIcon from '../../assets/icons/BPS Icon - Market Research.png';
import EmployeeRewardsIcon from '../../assets/icons/BPS Icon - Employee Rewards.png';
import EbikeIcon from '../../assets/icons/BPS Icon - Ebike.png';
import CustomIncentiveIcon from '../../assets/icons/BPS Icon - Custom Incentives.png';
import RecallIcon from '../../assets/icons/BPS Icon - Recall & Warranty.png';
import SolarIcon from '../../assets/icons/BPS Icon - Solar.png';
import ReferralIcon from '../../assets/icons/BPS Icon - Referral.png';


const ProductCards1 = () => {
    return (
        <>
            <Container fluid>
                <Row>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/channel-sales'>
                            <img src={ChannelIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Partner Up</h5>
                            <p>
                                Our revolutionary channel sales incentive system
                            </p>
                            <BPSArrowLink href="/channel-sales">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/sales-contests'>
                            <img src={SalesContestIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Up Swing</h5>
                            <p>
                                Our sales contests solution
                            </p>
                            <BPSArrowLink href="/sales-contests">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/rebates'>
                            <img src={RebateIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Rebate Automater</h5>
                            <p>
                                Our rebate program platform
                            </p>
                            <BPSArrowLink href="/rebates">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                    <Col md={6} className="my-2">
                        <HoverCardShadow href='/referrals'>
                            <img src={ReferralIcon} width={60} className="pb-2" />
                            <h5 className='fs-20 color-sky-tint-1'>Referral Pro</h5>
                            <p>
                                Our platform for referral programs
                            </p>
                            <BPSArrowLink href="/referrals">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardShadow>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

const ProductCards2 = () => {
    return (
        <>
            <Container fluid>
                <Row className="justify-content-center">
                    <Col xl={4} md={6} className="my-2">
                        <HoverCardBorderLink href='/ebike-incentives'>
                            <h3 className='fs-20'>
                                <img src={EbikeIcon} width={48} className="me-3" />
                                Ebike Incentives
                            </h3>
                            <BPSArrowLink href="/ebike-incentives">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                    <Col xl={4} md={6} className="my-2">
                        <HoverCardBorderLink href='/payments'>
                            <h3 className='fs-20'>
                                <img src={RecallIcon} width={48} className="me-3" />
                                Recall & warranty payments
                            </h3>
                            <BPSArrowLink href="/payments">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                    <Col xl={4} md={6} className="my-2">
                        <HoverCardBorderLink href='/custom-incentive-programs'>
                            <h3 className='fs-20'>
                                <img src={CustomIncentiveIcon} width={48} className="me-3" />
                                Unique custom programs
                            </h3>
                            <BPSArrowLink href="/custom-incentives-programs">Learn More<Arrow /></BPSArrowLink>
                        </HoverCardBorderLink>
                    </Col>
                    <Col xl={3} md={6} className='my-2'>
                        <HoverCardBorderLink>
                            <h3 className='fs-20'>
                                <img src={MarketResearchIcon} width={48} className="me-3" />
                                Market research
                            </h3>
                        </HoverCardBorderLink>
                    </Col>
                    <Col xl={3} md={6} className='my-2'>
                        <HoverCardBorderLink>
                            <h3 className='fs-20'>
                                <img src={RideshareIcon} width={48} className="me-3" />
                                Rideshare programs
                            </h3>
                        </HoverCardBorderLink>
                    </Col>

                    <Col xl={3} md={6} className="my-2">
                        <HoverCardBorderLink className='col-md-2'>
                            <h3 className='fs-20'>
                                <img src={SolarIcon} width={48} className="me-3" />
                                Solar incentives
                            </h3>
                        </HoverCardBorderLink>
                    </Col>
                    <Col xl={3} md={6} className="my-2">
                        <HoverCardBorderLink href='/employee-rewards'>
                            <h3 className='fs-20'>
                                <img src={EmployeeRewardsIcon} width={48} className="me-3" />
                                Employee rewards
                            </h3>
                        </HoverCardBorderLink>
                    </Col>

                </Row>
            </Container >
        </>
    );
}

export { ProductCards1, ProductCards2 }
